import { useContext, useEffect, useState } from "react";

import { Spinner } from "@salesforce/design-system-react";

import { Asset } from "sfmc";

import { Alert } from "../../components/Alert";

import EmbedInEmailContext from "../../contexts/embedInEmailContext";
import { upsertAsset } from "../../sfmcClient";

interface Props {
    onComplete: () => void;
}

export function CreateAsset(props: Props) {
    const [embedInEmailContextState, setEmbedInEmailContextState] =
        useContext(EmbedInEmailContext);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [createdAsset, setCreatedAsset] = useState<Asset>();
    const { onComplete } = props;

    async function doUpsertAssert() {
        const imgUrl = embedInEmailContextState.createAssetWithPlayButton
            ? embedInEmailContextState.imgUrlWithPlayButton
            : embedInEmailContextState.imgUrl;
        const imgTag = `<img src="${imgUrl}" style="width: 100%" title="${embedInEmailContextState.name}" />`;

        return await upsertAsset(
            `${embedInEmailContextState.videoId!}-${
                embedInEmailContextState.selectedImgType
            }`,
            `${embedInEmailContextState.name!}-${
                embedInEmailContextState.selectedImgType
            }`,
            embedInEmailContextState.link !== "none"
                ? `<a href="${embedInEmailContextState.link}">${imgTag}</a>`
                : imgTag
        );
    }

    useEffect(() => {
        if (
            !embedInEmailContextState.videoId ||
            !embedInEmailContextState.name ||
            !embedInEmailContextState.imgUrl ||
            !embedInEmailContextState.imgUrlWithPlayButton ||
            !embedInEmailContextState.link
        ) {
            return;
        }

        doUpsertAssert()
            .then((asset: Asset) => {
                setCreatedAsset(asset);
            })
            .catch((err) => {
                setError(err.message);
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!createdAsset) {
            return;
        }

        setEmbedInEmailContextState({
            ...embedInEmailContextState,
            asset: createdAsset,
        });
        onComplete();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createdAsset]);

    async function retryUpsert() {
        setError("");
        setLoading(true);

        try {
            const asset = await doUpsertAssert();
            setCreatedAsset(asset);
        } catch (err: any) {
            setError(err.message);
        }
        setLoading(false);
    }

    return (
        <div className="slds-var-p-around_medium">
            {!error && (
                <div className="slds-text-heading_small slds-var-m-bottom_medium">
                    Porting your asset to Content Builder
                </div>
            )}

            {error && (
                <Alert
                    alertMsg={error}
                    disableClose={true}
                    action={{ label: "Retry", onClick: retryUpsert }}
                    variant="slds-alert_error"
                />
            )}

            {loading && <Spinner />}
        </div>
    );
}
